import * as React from "react";
import type { IAppCommandPromptProvider } from "./appcommandprompt";

export const menuSearchCommand = "e";
export const shardSearchCommand = "s";
export const inwinkSearchCommand = "k";

export const commandPriorities = ["s", "e", "k"];

export interface IAppCommandPromptRegistration {
    trigger: string;
    standalone?: boolean;
    providers: IAppCommandPromptProvider[];
}

export interface IAppCommandPromptContext {
    triggers: string[];
    isSearcheable() : boolean;
    defaultKey();
    triggerFor(key: string);
    registerCommands: (commands: IAppCommandPromptRegistration) => void;
    unregisterCommands: (commands: IAppCommandPromptRegistration) => void;
}

export const AppCommandPromptContext = React.createContext<IAppCommandPromptContext>(null);
